import { AdminAccessOnCharts, DashboardAddDeleteArragneCharts, TypeFunctional } from '../../constants/defaultValues';
import { formatDates } from '../../utils/formatDates ';
import { DashboarPageActionTypes } from './constants';

interface State {
    isChangeLayout: boolean,
    layoutBreakpoint: string,
    layout: any,
    isSlideShow: boolean,
    isSlideShowPause: boolean,
    locationId: string,
    config?: any | {};
    isLoading: boolean,
    isDrag: boolean,
    copyChart: boolean,
    chartList: any[],
    filterMenuList: any[],
    filterTagList: any[],
    filterTags: any[]
}

const INIT_STATE = {
    isChangeLayout: false,
    layoutBreakpoint: "lg",
    layout: {
        lg: [],
        md: [],
        sm: [],
        xs: []
    },
    isSlideShow: false,
    isSlideShowPause: false,
    locationId: '',
    copyChart: false,
    isLoading: false,
    isDrag: false,
    chartList: [],
    error: "",
    isLoadingFilter: false,
    filterMenuList: [],
    filterTagList: [],
    filterTags: [],

    config: {
        isChangeCharts: false,
    },
};

const DashboardPage = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {

        case DashboarPageActionTypes.CHANGE_CHARTS_LOCATION:
            return {
                ...state,
                locationId: action.payload,
                isLoading: true
            };

        case DashboarPageActionTypes.CHANGE_COPY_CHARTS:
            const isChangeChartsCopy = state.config.isChangeCharts

            return {
                ...state,
                copyChart: action.payload,

                config: {
                    ...state.config,
                    isChangeCharts: isChangeChartsCopy
                }
            };

        case DashboarPageActionTypes.CHANGE_CHARTS_GET_LOAD:
            return {
                ...state,
                isLoading: true
            }

        // case DashboarPageActionTypes.:
        //     return {
        //         ...state,
        //         isDrag: true
        //     };

        case DashboarPageActionTypes.CHANGE_CHARTLAYOUTS:
            let copyChartList = state.chartList;
            let item = copyChartList.find(i => i.id.toString() === action.payload.sChartId);
            let s_chartMenuPages: any = item?.chartMenuPages?.filter((x: any) => x.sMenuPageId === action.payload.sMenuPageId && x.sChartId === item.id)
            let v = s_chartMenuPages[0];
            v.details = action.payload.details
            return {
                ...state,
                chartList: copyChartList,
                isLoading: false,
            };


        case DashboarPageActionTypes.CHANGE_IS_CHANGELAYOUT:
            return {
                ...state,
                isChangeLayout: action.payload,
            };

        case DashboarPageActionTypes.CHANGE_LAYOUT_UPDATE_FROMPAGE:
            return {
                ...state,
                layoutBreakpoint: action.payload,
            };



        case DashboarPageActionTypes.CHANGE_CHARTS:
            const isChangeCharts = state.config.isChangeCharts

            const c = action.payload.data && action.payload.data?.length > 0 ? action.payload.data?.map((co: any) => ({ ...co.sChart, styleBtnShowOnHover: { display: 'none' } })) : []
            const result: any = {
                lg: [],
                md: [],
                sm: [],
                xs: [],
            };

            const s_DefaultLayout: any = {
                x: 0,
                y: 0,
                w: 8,
                h: 5
            }

            c.map((c: any) => {              
                const s_chartMenuPages = c?.chartMenuPages;                
                if (s_chartMenuPages && s_chartMenuPages[0] && s_chartMenuPages[0]?.chartMenuPageUsers) {                   
                    if (s_chartMenuPages[0]?.chartMenuPageUsers[0] && s_chartMenuPages[0]?.chartMenuPageUsers[0]?.details && s_chartMenuPages[0]?.chartMenuPageUsers[0]?.details!="" && s_chartMenuPages[0]?.chartMenuPageUsers[0]?.details!=null && JSON.parse(s_chartMenuPages[0]?.chartMenuPageUsers[0]?.details)?.layout) {                                            
                            let le: any = JSON.parse(s_chartMenuPages[0]?.chartMenuPageUsers[0]?.details)?.layout;                            
                                if (le?.lg === undefined && le?.md === undefined && le?.sm === undefined && le?.xs === undefined) {
                                    if (le === "" || le === undefined) {
                                        result.lg.push({ ...s_DefaultLayout, i: c.id });
                                        result.md.push({ ...s_DefaultLayout, i: c.id });
                                        result.sm.push({ ...s_DefaultLayout, i: c.id });
                                        result.xs.push({ ...s_DefaultLayout, i: c.id });
                                    }
                                    else {
                                        result.lg.push({ ...le, i: c.id });
                                        result.md.push({ ...le, i: c.id });
                                        result.sm.push({ ...le, i: c.id });
                                        result.xs.push({ ...le, i: c.id });
                                    }
                                }
                                else {
                                    if (le?.lg) {
                                        result.lg.push({ ...le?.lg, i: c.id });
                                    }
                                    else
                                        result.lg.push({ ...s_DefaultLayout, i: c.id });

                                    if (le?.md) {
                                        result.md.push({ ...le?.md, i: c.id });
                                    }
                                    else
                                        result.md.push({ ...s_DefaultLayout, i: c.id });

                                    if (le?.sm) {
                                        result.sm.push({ ...le?.sm, i: c.id });
                                    }
                                    else
                                        result.sm.push({ ...s_DefaultLayout, i: c.id });

                                    if (le?.xs) {
                                        result.xs.push({ ...le?.xs, i: c.id });
                                    }
                                    else
                                        result.xs.push({ ...s_DefaultLayout, i: c.id });
                                }                                                    
                    }
                    else
                    {

                        if (s_chartMenuPages[0]?.details && JSON.parse(s_chartMenuPages[0]?.details)?.layout) {
                            let le: any = JSON.parse(s_chartMenuPages[0]?.details)?.layout;                            
                            if (le?.lg === undefined && le?.md === undefined && le?.sm === undefined && le?.xs === undefined) {
                                if (le === undefined) {
                                    result.lg.push({ ...s_DefaultLayout, i: c.id });
                                    result.md.push({ ...s_DefaultLayout, i: c.id });
                                    result.sm.push({ ...s_DefaultLayout, i: c.id });
                                    result.xs.push({ ...s_DefaultLayout, i: c.id });
                                }
                                else
                                    if (JSON.stringify(le) === '{}' || le === "") {
                                        result.lg.push({ ...s_DefaultLayout, i: c.id });
                                        result.md.push({ ...s_DefaultLayout, i: c.id });
                                        result.sm.push({ ...s_DefaultLayout, i: c.id });
                                        result.xs.push({ ...s_DefaultLayout, i: c.id });
                                    }
                                    else {
                                        result.lg.push({ ...le, i: c.id });
                                        result.md.push({ ...le, i: c.id });
                                        result.sm.push({ ...le, i: c.id });
                                        result.xs.push({ ...le, i: c.id });
                                    }
                            }
                            else {
                                if (le?.lg) {
                                    result.lg.push({ ...le?.lg, i: c.id });
                                }
                                else
                                    result.lg.push({ ...s_DefaultLayout, i: c.id });

                                if (le?.md) {
                                    result.md.push({ ...le?.md, i: c.id });
                                }
                                else
                                    result.md.push({ ...s_DefaultLayout, i: c.id });

                                if (le?.sm) {
                                    result.sm.push({ ...le?.sm, i: c.id });
                                }
                                else
                                    result.sm.push({ ...s_DefaultLayout, i: c.id });

                                if (le?.xs) {
                                    result.xs.push({ ...le?.xs, i: c.id });
                                }
                                else
                                    result.xs.push({ ...s_DefaultLayout, i: c.id });
                            }
                        }
                        else {
                            result.lg.push({ ...s_DefaultLayout, i: c.id });
                            result.md.push({ ...s_DefaultLayout, i: c.id });
                            result.sm.push({ ...s_DefaultLayout, i: c.id });
                            result.xs.push({ ...s_DefaultLayout, i: c.id });
                        }
                    }
                }
            });


            let s_ResultSAecurity = false;
            //const s_IsAdmin = action.payload?.userSecurity?.filter((s: any) => s.action === AdminAccessOnCharts && s.objectType === TypeFunctional)?.length > 0

            const s_result = action.payload?.userSecurity?.filter((s: any) => s.action === DashboardAddDeleteArragneCharts && s.objectType === TypeFunctional)?.length > 0
            if (s_result)
                s_ResultSAecurity = true

            return {
                ...state,
                chartList: c,
                layout: result,
                isLoading: false,
                isDrag: s_ResultSAecurity,
                error: c && c?.length === 0 && action.payload.data?.message != "" ? action.payload.data?.message : "",
                config: {
                    ...state.config,
                    isChangeCharts: isChangeCharts
                }
            };

        case DashboarPageActionTypes.CHANGE_CHARTS_SHOWBTNONHOVER:
            const indexChart = state.chartList.findIndex(object => { return object.id === action.payload.id })
            const s_charts = state.chartList;
            if (indexChart !== -1) {
                if (action.payload.enter)
                    s_charts[indexChart].styleBtnShowOnHover = { display: 'block' };
                else
                    s_charts[indexChart].styleBtnShowOnHover = { display: 'none' };
            }

            return {
                ...state,
                chartList: s_charts
            };

        case DashboarPageActionTypes.CHANGE_CHARTS_FILTER:
            const isChangeFilterCharts = state.config.isChangeCharts

            return {
                ...state,
                chartList: action.payload,
                isLoading: false,

                config: {
                    ...state.config,
                    isChangeCharts: !isChangeFilterCharts
                }
            };

        case DashboarPageActionTypes.CHANGE_CHARTS_DIM:
            const isChangeFilterChartsDim = state.config.isChangeCharts

            return {
                ...state,
                chartList: action.payload,
                isLoading: false,

                config: {
                    ...state.config,
                    isChangeCharts: !isChangeFilterChartsDim
                }
            };


        case DashboarPageActionTypes.CHANGE_FILTERMENULIST:
            //const isChangeCharts = state.config.isChangeCharts
            const cf = action.payload && action.payload?.length > 0 ? action.payload?.map((co: any) => ({ ...co, value: '', data: [] })) : []

            return {
                ...state,
                filterMenuList: cf,
                filterMenuTag: [],
                filterTagList: [],
                isLoadingFilter: false
            };

        case DashboarPageActionTypes.CHANGE_FILTERMENUDATA:
            const s_filterMenuListdd = state.filterMenuList
            const indexdd = state.filterMenuList.findIndex(object => { return object.colName === action.payload.colName })

            if (indexdd !== -1) {
                s_filterMenuListdd[indexdd].data = action.payload.data;
            }
            //const isChangeCharts = state.config.isChangeCharts
            //const cd = action.payload && action.payload.length > 0 ? action.payload?.map((co: any) => ({ ...co, value: '',data:[] })) : []

            return {
                ...state,
                filterMenuList: s_filterMenuListdd,
                //isLoadingFilter: false
            };


        case DashboarPageActionTypes.CHANGE_FILTERMENUVALUE:
            const isChangeFilterChartsf = state.config.isChangeCharts
            let s_filterMenuList = state.filterMenuList;
            let s_filterTagListf = state.filterTagList;
            let ch: any = state.chartList;


            const { dataf } = action.payload
            const s_IsRange = dataf?.isRange !== undefined ? dataf?.isRange : false
            if (dataf?.isRemoveAll) {
                s_filterMenuList.map((x: any) => {
                    x.value = [];
                })

                s_filterTagListf = []

                //change FilterList Any Chart
                ch.map((i: any) => {
                    var s_DetailPerChart: any = JSON.parse(i.details)
                    s_DetailPerChart.config.sanjabProp.filterList = []
                    s_DetailPerChart.config.sanjabProp.drillList = undefined
                    i.details = JSON.stringify(s_DetailPerChart)
                }
                )
            }

            else {
                let vo = dataf.value;

                //change Filter Value
                const index = s_filterMenuList.findIndex(object => { return object.colName === dataf.colName })
                if (index !== -1) {
                    s_filterMenuList[index].value = vo;
                    if (dataf?.isRange != undefined)
                        s_filterMenuList[index].isRange = dataf.isRange;
                }

                //Change Tag Value
                let voTag = vo
                const indexTag = s_filterTagListf.findIndex(x => x.colName === dataf.colName)
                if (s_IsRange) {
                    if (vo?.length > 0) {
                        voTag = formatDates(vo)
                    }
                }
                if (indexTag !== -1) {
                    if (vo?.length > 0)
                        s_filterTagListf[indexTag].value = voTag;
                    else
                        s_filterTagListf = s_filterTagListf.filter(x => x.colName !== dataf.colName)
                }
                else
                    if (vo?.length > 0)
                        s_filterTagListf.push({ colName: dataf.colName, value: voTag, sDataSourceId: dataf.sDataSourceId })

                //change FilterList Any Chart
                ch.map((i: any) => {
                    if (i.sDatasourceId === dataf.sDataSourceId) {
                        var s_DetailPerChart: any = JSON.parse(i.details)

                        //change Filter Per Chart                    
                        let filterPerChart = s_DetailPerChart.config.sanjabProp.filterList
                        const filterPerChartIndex = filterPerChart.findIndex((x: any) => x.filterCol === dataf.colName)

                        if (filterPerChartIndex !== -1) {
                            filterPerChart[filterPerChartIndex].filterArray = vo
                            filterPerChart[filterPerChartIndex].isRange = s_IsRange
                        }
                        else {
                            const newFilter = {
                                filterArray: vo,
                                filterCol: dataf.colName,
                                operatorName: "in",
                                s_IsRange: s_IsRange
                            }
                            filterPerChart = [...filterPerChart, newFilter]
                        }
                        s_DetailPerChart.config.sanjabProp.filterList = filterPerChart;
                        i.details = JSON.stringify(s_DetailPerChart)
                        ///////////////////////////

                        //change Drill Per Chart
                        let drillPerChart: any = s_DetailPerChart.config.sanjabProp.drillList;
                        if (drillPerChart && JSON.stringify(drillPerChart) !== '{}') {
                            const drilItemIndex = drillPerChart?.steps?.findIndex((x: any) => x.name === dataf.colName)
                            if (drilItemIndex !== -1) {
                                const valueSteps: any = drillPerChart?.steps[drilItemIndex].value
                                if (!vo.includes(valueSteps)) {
                                    const removestateFromChart = drillPerChart?.steps.filter((x: any) => x.name !== dataf.colName)
                                    drillPerChart.steps = removestateFromChart;
                                    if (drillPerChart?.steps?.length > 0) {
                                        const newDrillSteps: any = []
                                        drillPerChart.steps.map((x: any, index: any) => {
                                            newDrillSteps.push({
                                                index: index,
                                                level: x.level,
                                                name: x.name,
                                                typeStep: x.typeStep,
                                                value: x.value
                                            })
                                        })
                                        const newDrill = {
                                            level: drillPerChart.steps[drillPerChart.steps?.length - 1].level,
                                            steps: newDrillSteps
                                        }
                                        s_DetailPerChart.config.sanjabProp.drillList = newDrill
                                    }
                                    else {
                                        s_DetailPerChart.config.sanjabProp.drillList = undefined

                                    }
                                    i.details = JSON.stringify(s_DetailPerChart)
                                }
                            }
                        }
                        ///////////////////////////
                    }
                }
                )
            }

            return {
                ...state,
                filterMenuList: s_filterMenuList,
                filterTagList: s_filterTagListf,
                chartList: ch,

                config: {
                    ...state.config,
                    isChangeCharts: !isChangeFilterChartsf
                }
            };

        case DashboarPageActionTypes.CHANGE_DRILLVALUE:
            const isChangeFilterChartsd = state.config.isChangeCharts
            let s_filterMenuListd = state.filterMenuList;
            let s_filterTagListd = state.filterTagList;
            let ch1: any = state.chartList;

            const { datad } = action.payload
            let vod = datad.value;

            ch1.map((i: any) => {
                if (i.id === datad.id) {
                    var chartDetails = JSON.parse(i.details)
                    const prevDrillChart = chartDetails.config.sanjabProp.drillList
                    chartDetails.config.sanjabProp.drillList = vod;
                    i.details = JSON.stringify(chartDetails)

                    const countPrevDrill = prevDrillChart && JSON.stringify(prevDrillChart) !== '{}' ? prevDrillChart.steps?.length : 0
                    if (vod.steps?.length > countPrevDrill) {
                        vod.steps.map((drillItem: any) => {
                            //change Filter Value
                            const index = s_filterMenuListd.findIndex(object => { return object.colName === drillItem.name })
                            if (index !== -1) {
                                if (datad.sDataSourceId === s_filterMenuListd[index].sDataSourceId && !s_filterMenuListd[index].value.includes(drillItem.value))
                                    s_filterMenuListd[index].value = [...s_filterMenuListd[index].value, drillItem.value]
                            }

                            //Change Tag Value
                            const indexTag = s_filterTagListd.findIndex(x => x.colName === drillItem.name)
                            if (indexTag !== -1) {
                                if (!s_filterTagListd[indexTag].value.includes(drillItem.value))
                                    s_filterTagListd[indexTag].value = [...s_filterTagListd[indexTag].value, drillItem.value]
                            }
                            else
                                s_filterTagListd.push({ colName: drillItem.name, value: [drillItem.value], sDataSourceId: datad.sDataSourceId })
                        })
                    }
                    else {
                        const difference = prevDrillChart?.steps.filter((prevItem: any) => !vod.steps.some((newItem: any) => newItem.name === prevItem.name));
                        difference.map((removeItem: any) => {
                            //change Filter Value
                            const index = s_filterMenuListd.findIndex(object => { return object.colName === removeItem.name })
                            if (index !== -1) {
                                if (datad.sDataSourceId === s_filterMenuListd[index].sDataSourceId && s_filterMenuListd[index].value.includes(removeItem.value))
                                    s_filterMenuListd[index].value = s_filterMenuListd[index].value.filter((f: any) => f !== removeItem.value)
                            }

                            //Change Tag Value
                            const indexTag = s_filterTagListd.findIndex(x => x.colName === removeItem.name)
                            if (indexTag !== -1) {
                                if (s_filterTagListd[indexTag].value.includes(removeItem.value)) {
                                    if (s_filterTagListd[indexTag].value?.length > 1)
                                        s_filterTagListd[indexTag].value = s_filterTagListd[indexTag].value.filter((f: any) => f !== removeItem.value)
                                    else
                                        s_filterTagListd = s_filterTagListd.filter((f: any) => f.colName !== removeItem.name)
                                }
                            }
                        })
                    }
                }
            })


            //change FilterList Any Chart
            ch1.map((i: any) => {
                var s_DetailPerChart: any = JSON.parse(i.details)
                let filterListNew: any = []
                s_filterTagListd.map((tagItem: any) => {
                    if (i.sDatasourceId === tagItem.sDataSourceId) {
                        filterListNew.push({
                            operatorName: "in",
                            filterArray: tagItem.value,
                            filterCol: tagItem.colName
                        })
                    }
                })
                s_DetailPerChart.config.sanjabProp.filterList = filterListNew;
                i.details = JSON.stringify(s_DetailPerChart)
            }
            )

            return {
                ...state,
                filterMenuList: s_filterMenuListd,
                filterTagList: s_filterTagListd,
                chartList: ch1,
                isLoading: false,

                config: {
                    ...state.config,
                    isChangeCharts: isChangeFilterChartsd
                }
            };

        case DashboarPageActionTypes.CHANGE_CHARTTYPEDASH:
            let chartType = action.payload.chartType
            let IsStack = action.payload.isStack
            let IsGroup = action.payload.isGroup

            let cht: any = state.chartList;


            cht.map((i: any) => {
                if (i.id === action.payload.id) {
                    var s_DetailPerChart: any = JSON.parse(i.details)
                    s_DetailPerChart.config.sanjabProp.chartType = "Table"
                    i.details = JSON.stringify(s_DetailPerChart)
                }
            }
            )

            return {
                ...state,
                chartList: cht,

                config: {
                    ...state.config,
                    //isChangeCharts: !isChangeFilterChartsf
                }
            };


        case DashboarPageActionTypes.CHANGE_FILTERMENU_ADD:
        case DashboarPageActionTypes.CHANGE_FILTERMENU_EDIT:
        case DashboarPageActionTypes.CHANGE_FILTERMENU_DELETE:
        case DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET_LOAD:
            return {
                ...state,
                isLoadingFilter: true
            };

        case DashboarPageActionTypes.CHANGE_IS_SLIDESHOW:
            return {
                ...state,
                isSlideShow: action.payload,
            };

        case DashboarPageActionTypes.CHANGE_IS_SLIDESHOWPAUSE:
            return {
                ...state,
                isSlideShowPause: action.payload,
            };


        default:
            return state;
    }
};

export default DashboardPage;
